import { render, staticRenderFns } from "./codeBox.vue?vue&type=template&id=0133a93f&scoped=true&"
import script from "./codeBox.vue?vue&type=script&lang=js&"
export * from "./codeBox.vue?vue&type=script&lang=js&"
import style0 from "./codeBox.vue?vue&type=style&index=0&id=0133a93f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0133a93f",
  null
  
)

export default component.exports